<template>
  <div class="avatars">
    <ul class="avatars__accordion" uk-accordion>
      <li class="">
        <a class="uk-accordion-title" href="#">Аватарки</a>
        <div class="uk-accordion-content">
          <div class="avatars__intro">Посмотри какие аватарки тебе доступны! Нажми на изображение, чтобы посмотреть его в крупном виде. Нажимай на кнопку применить, чтобы поставить аватарку себе!</div>
          <div v-if="!isEmpty">
            <div class="avatars__blocks" v-for="(block, i) in items" :key="block.id">
              <div class="avatars__status">{{ i + 1}}. {{ block.title }}</div>
              <ul class="avatars__items">
                <li v-for="ava in block.avatars" class="avatars__item" uk-lightbox="toggle: .avatars__full" :key="ava.id">
                  <a class="avatars__full" :href="ava.image.path" :data-caption="ava.title">
                    <img :src="ava.image.path" alt="">
                  </a>
                  <div class="avatars__title">{{ ava.title }}</div>
                  <div class="avatars__button">
                    <a href="#" @click.prevent="applyAvatar(ava.id)">Применить</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "avatars",
  data() {
    return {
      items: ''
    }
  },
  watch: {
    'user': 'getAvatars'
  },
  inject: ['http'],
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    isEmpty() {
      return _.isEmpty(this.items);
    }
  },
  methods: {
    async getAvatars() {
      if (this.user && this.user.id && this.user.status_id) {
        let data = {
          'status_id': this.user.status.id
        }
        let res = await this.http.post('onGetAvailableAvatars', data).then(res => res.data)
        this.items = res;
      }
    },
    async applyAvatar(id) {
      let data = {
        'user_id': this.user.id,
        'avatar_id': id
      };
      let res = await this.http.post('onSetStudentAvatar', data).then(res => res.data)
      this.$store.commit('setUser', res);
      swal('Аватар изменен', '', 'success');
    }
  },
  mounted() {
    this.getAvatars();
  }
}
</script>